// extracted by mini-css-extract-plugin
export default {"CircleBadge":"MarketplaceListings-module__CircleBadge__k6Pf9EF"};